<script lang="ts">
  import DeleteIcon from '$icons/DeleteIcon.svelte';
  import XIcon from '$icons/XIcon.svelte';
  import { getPostEditor } from '$lib/stores/postEditorStore';
  import Button from '../../Button.svelte';
  import CornerSquare from '../../wrappers/CornerSquare.svelte';
  import DotGrid from '../../DotGrid.svelte';

  export let open: boolean;
  const { close } = getPostEditor();

  function discardPost() {
    close();
    open = false;
  }

  function keepEditing() {
    open = false;
  }
</script>

{#if open}
  <div class="relative z-[100]">
    <button
      class="fixed inset-0 z-[101] flex flex-col items-center justify-center bg-black/80 p-4"
      on:click={() => (open = false)}
    >
      <CornerSquare class="flex !h-fit w-full max-w-[616px] flex-col">
        <div
          class="gap-x-md border-gray-dark-2 bg-gray-dark-1 px-lg py-md flex w-full items-center border-b-2"
        >
          <h2
            class="text-normal font-architekt text-gray-dark-12 min-w-0 break-words text-left text-sm leading-6 sm:text-base"
          >
            What would you like to do with your post?
          </h2>
          <DotGrid class="shrink-0" />
          <button class="shrink-0" on:click={() => (open = false)}>
            <XIcon class="text-gray-dark-11" />
          </button>
        </div>
        <div class="bg-gray-dark-0 px-md sm:px-2xl py-lg sm:py-xl w-full">
          <div class="flex flex-row gap-x-2">
            <Button class="w-full" danger size="sm" on:click={discardPost}>
              <DeleteIcon slot="left-icon" />
              Discard
            </Button>
            <Button class="w-full" tertiary size="sm" on:click={keepEditing}>Keep editing</Button>
          </div>
        </div>
      </CornerSquare>
    </button>
  </div>
{/if}
